import { useEffect, useState } from 'react'

import { MOBILE_SHELL_MEDIA } from '@/config/layoutBreakpoints'

/** Viewport bajo el breakpoint de shell móvil (teléfono, <768px). */
export function useMobileShellMedia() {
  const [isMobileShell, setIsMobileShell] = useState(() => {
    if (typeof window === 'undefined') return false
    return window.matchMedia(MOBILE_SHELL_MEDIA).matches
  })

  useEffect(() => {
    const media = window.matchMedia(MOBILE_SHELL_MEDIA)
    const onChange = () => setIsMobileShell(media.matches)
    onChange()
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return isMobileShell
}
